export default {
  navigation: {
    next: "ถัดไป",
    back: "ย้อนกลับ",
    surveyNavigation: "การนำทางแบบสำรวจ",
    workspace: {
      home: "หน้าแรก",
      example: "ตัวอย่าง"
    }
  }
}
